"use client";

import { usePathname } from "next/navigation";
import Header from "../header";
import Footer from "../footer";

export default function LayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith("/admin");
  const hideFooter = pathname?.startsWith("/dashboard");

  return (
    <>
      {!isAdmin && <Header />}
      {children}
      {!hideFooter && <Footer />}
    </>
  );
}
